import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { useNavigate } from 'react-router-dom';

const DocRequest = () => {
    const [selectedUserId, setSelectedUserId] = useState('');
    const [selectedUsername, setSelectedUsername] = useState('');
    const [requestType, setRequestType] = useState(''); // State for request type
    const [users, setUsers] = useState([]); // Store the fetched users
    const [error, setError] = useState(''); // Error state
    const [successMessage, setSuccessMessage] = useState(null); // Success message state
    const [isSubmitting, setIsSubmitting] = useState(false); // State to handle submission status
    const emp_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    

    const handleRequestTypeChange = (e) => {
        setRequestType(e.target.value);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch user data
                const userResponse = await fetch('https://apiaksharaconnect.aksharafinalytics.in/users');

                if (!userResponse.ok) {
                    throw new Error('Failed to fetch users');
                }

                const userResult = await userResponse.json();
                setUsers(userResult.user || []); // Set the fetched users

            } catch (error) {
                setError(error.message); // Set error message
            }
        };

        fetchData();
    }, []);

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!selectedUserId || !requestType) {
            setError('User ID, and Request Type are required.');
            return;
        }

        setIsSubmitting(true); // Start submission

        const formData = new FormData();
        formData.append('user_id', selectedUserId); // Use selectedUserId as user_id
        formData.append('emp_id', emp_id); // Use emp_id
        formData.append('request_type', requestType); // Add request_type to formData

        try {
            const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/CreateRequest', {
                method: 'POST',
                body: formData,
            });

            const res = await response.json();
            console.log(res);
            if (res.status === 'success') {
                setSuccessMessage(res.message);
               
                setSelectedUserId('');
                setSelectedUsername('');
                setRequestType('');
                
            } else {
                setError(res.message);
            }
        } catch (error) {
            //setError('An error occurred while submitting the request.');
        } finally {
            setIsSubmitting(false); // Stop submitting
        }
    };

    // Update selectedUserId and selectedUsername when a user is selected from the dropdown
    const handleUserSelection = (e) => {
        const selectedUser = users.find(user => user.id === e.target.value);
        if (selectedUser) {
            setSelectedUserId(selectedUser.id);
            setSelectedUsername(selectedUser.name);
        }
    };

    return (
        <>
            <Header />

            <div className="container mt-5">
            {error && <div className="alert alert-danger">{error}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}
                <div className="card shadow">
                    <div className="card-header">
                        <h4>
                            Documents Request Form &nbsp;
                            <button className="btn btn-primary" onClick={() => navigate('/ReplyDoc')}>
                                View Doc Request
                            </button>
                        </h4>
                    </div>
                    <br />
                    

                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Select User</label>
                                <select className="form-select" value={selectedUserId} onChange={handleUserSelection}>
                                    <option value="">Select User</option>
                                    {users.map((user) => (
                                        <option key={user.id} value={user.id}>
                                            {user.company}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Request Type</label>
                                <textarea className="form-control" value={requestType} onChange={handleRequestTypeChange} placeholder="Enter the request type" required></textarea>
                            </div>
                            <br/>
                            <center>
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>{isSubmitting ? 'Submitting...' : 'Submit'}</button>
                            </center>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocRequest;
